import { createRoot } from 'react-dom/client';
// import App from './App';
import App from '../../src/renderer/App';
import React, { Component } from 'react';
import '../../src/renderer/App.scss';
import '../../src/renderer/onlineChat.css';
import '../../src/renderer/theme.scss';
import ChooseLanguage from '../../src/renderer/functions/chooseLanguage';
import CookieFunction from '../../src/renderer/functions/cookieFunction';
import SeoHead from '../../src/renderer/components/SeoHead';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
{
  /* <link rel="manifest" href="%PUBLIC_URL%/manifest.json" />; */
}

// import App from './App';
const electron = false;
// replace console.* for disable log on production
// if (process.env.NODE_ENV === 'production') {
console.log = () => {};
console.error = () => {};
console.debug = () => {};
console.clear();

let content = ChooseLanguage(CookieFunction('get', 'ochattLang'))?.content;

console.log('hhhh', CookieFunction('get', 'ochattLang'));
const container = document.getElementById('root');
document.title = content?.name;

var link = document.createElement('meta');
link.setAttribute('name', 'viewport');
link.content =
  'width=device-width, initial-scale=1, maximum-scale=1 user-scalable=0';
document.getElementsByTagName('head')[0].appendChild(link);

var linkDesc = document.createElement('meta');
linkDesc.setAttribute('name', 'description');
linkDesc.content = content?.description;
document.getElementsByTagName('head')[0].appendChild(linkDesc);

var icon16 = document.createElement('link');
icon16.setAttribute('rel', 'icon');
icon16.href = './icon16x16.png';
icon16.sizes = '16x16';
icon16.type = 'image/png';
document.getElementsByTagName('head')[0].appendChild(icon16);

var icon40 = document.createElement('link');
icon40.setAttribute('rel', 'icon');
icon40.href = './icon40x40.png';
icon40.sizes = '40x40';
icon40.type = 'image/png';
document.getElementsByTagName('head')[0].appendChild(icon40);

var icon72 = document.createElement('link');
icon72.setAttribute('rel', 'icon');
icon72.href = './icon72x72.png';
icon72.sizes = '72x72';
icon72.type = 'image/png';
document.getElementsByTagName('head')[0].appendChild(icon72);

var icon144 = document.createElement('link');
icon144.setAttribute('rel', 'icon');
icon144.href = './icon144.png';
icon144.sizes = '144x144';
icon144.type = 'image/png';
document.getElementsByTagName('head')[0].appendChild(icon144);

var icon192 = document.createElement('link');
icon192.setAttribute('rel', 'icon');
icon192.href = './icon192x192.png';
icon192.sizes = '192x192';
icon192.type = 'image/png';
document.getElementsByTagName('head')[0].appendChild(icon192);

var icon196 = document.createElement('link');
icon196.setAttribute('rel', 'icon');
icon196.href = './icon196x196.png';
icon196.sizes = '196x196';
icon196.type = 'image/png';
document.getElementsByTagName('head')[0].appendChild(icon196);

var icon256 = document.createElement('link');
icon256.setAttribute('rel', 'icon');
icon256.href = './icon256x256.png';
icon256.sizes = '256x256';
icon256.type = 'image/png';
document.getElementsByTagName('head')[0].appendChild(icon256);

var icon512 = document.createElement('link');
icon512.setAttribute('rel', 'icon');
icon512.href = './icon.png';
icon512.sizes = '512x512';
icon512.type = 'image/png';
document.getElementsByTagName('head')[0].appendChild(icon512);

var icon1024 = document.createElement('link');
icon1024.setAttribute('rel', 'icon');
icon1024.href = './icon1024x1024.png';
icon1024.sizes = '1024x1024';
icon1024.type = 'image/png';
document.getElementsByTagName('head')[0].appendChild(icon1024);

var appleIcon512 = document.createElement('link');
appleIcon512.setAttribute('rel', 'apple-touch-icon');
appleIcon512.href = './icon.png';
appleIcon512.sizes = '512x512';
appleIcon512.type = 'image/png';
document.getElementsByTagName('head')[0].appendChild(appleIcon512);

var appleIcon256 = document.createElement('link');
appleIcon256.setAttribute('rel', 'apple-touch-icon');
appleIcon256.href = './icon256x256.png';
appleIcon256.sizes = '256x256';
appleIcon256.type = 'image/png';
document.getElementsByTagName('head')[0].appendChild(appleIcon256);

var appleIcon144 = document.createElement('link');
appleIcon144.setAttribute('rel', 'apple-touch-icon');
appleIcon144.href = './icon144x144.png';
appleIcon144.sizes = '144x144';
appleIcon144.type = 'image/png';
document.getElementsByTagName('head')[0].appendChild(appleIcon144);

var appleIcon40 = document.createElement('link');
appleIcon40.setAttribute('rel', 'apple-touch-icon');
appleIcon40.href = './icon40x40.png';
appleIcon40.sizes = '40x40';
appleIcon40.type = 'image/png';
document.getElementsByTagName('head')[0].appendChild(appleIcon40);

var meta0 = document.createElement('meta');
meta0.setAttribute('name', 'apple-mobile-web-app-capable');
meta0.content = 'yes';
document.getElementsByTagName('head')[0].appendChild(meta0);

var meta1 = document.createElement('meta');
meta1.setAttribute('name', 'apple-mobile-web-app-status-bar-style');
meta1.content = 'default';
document.getElementsByTagName('head')[0].appendChild(meta1);

var meta2 = document.createElement('meta');
meta2.setAttribute('property', 'og:site_name');
meta2.content = 'Ochatt';
document.getElementsByTagName('head')[0].appendChild(meta2);
{
  /* <meta property='og:site_name' content='oChatt' /> */
}
var meta3 = document.createElement('meta');
meta3.setAttribute('property', 'og:title');
meta3.content = 'Ochatt';
document.getElementsByTagName('head')[0].appendChild(meta3);

{
  /* <meta
property='og:title'
content={` ${seoObject?.name} | کلیپشو `}
/> */
}
// var meta4 = document.createElement('meta');
// meta4.setAttribute('property', 'og:description');
// meta4.content = 'Ochatt';
// document.getElementsByTagName('head')[0].appendChild(meta4);
{
  /* <meta
property='og:description'
content={`${seoObject?.description}`}
/> */
}
var meta5 = document.createElement('meta');
meta5.setAttribute('property', 'og:description');
meta5.content =
  'Step into our chat app and unlock a new dimension of communication.  Chat, connect, and create memorable conversations.';
document.getElementsByTagName('head')[0].appendChild(meta5);
{
  /* <meta
property='og:type'
content='website'
/> */
}
// var meta6 = document.createElement('meta');
// meta6.setAttribute('property', 'og:image');
// meta6.content = './icon.png';
// document.getElementsByTagName('head')[0].appendChild(meta6);
{
  /* <meta
property='og:image'
content={`${seoObject?.imageUrl}`}
/> */
}
var meta7 = document.createElement('meta');
meta7.setAttribute('property', 'og:type');
meta7.content = 'website';
document.getElementsByTagName('head')[0].appendChild(meta7);

var manifest = document.createElement('link');
manifest.setAttribute('rel', 'manifest');
manifest.href = process.env.PUBLIC_URL + 'manifest.json';
document.getElementsByTagName('head')[0].appendChild(manifest);
// document.getElementsByTagName('head').innerHTML = <SeoHead />;
// document.getElementsByTagName('head')[0].appendChild(<SeoHead />);

const root = createRoot(container);
root.render(
  <>
    {/* <SeoHead /> */}
    <App electron={electron} />
  </>
);

serviceWorkerRegistration.unregister();
reportWebVitals();

// console.log(`window.process====${window.process}`);
// calling IPC exposed from preload script
// if (process.env.electron) {
//   window.electron.ipcRenderer.once('ipc-example', (arg) => {
//     // eslint-disable-next-line no-console
//     console.log(arg);
//   });
//   window.electron.ipcRenderer.sendMessage('ipc-example', ['ping']);
// }
